<template>
  <div>
    <div v-if="!acknowledgementsOption">
      <div class="alginCenterDiv infoDialogRemoveTransition">
        <button
          tabindex="0"
          class="
            text-purple-600
            font-bold
            cursor-pointer
            infoDialogRemoveTransition
            dark:text-white
          "
          style="position: relative; z-index: 5; padding-top: 10px"
          v-on:click="acknowledgementsClicked"
          aria-label="About the app"
        >
          About
        </button>
      </div>
    </div>
    <div v-if="acknowledgementsOption">
      <div v-on:click="acknowledgementsClosed" class="infoOverlay"></div>
    </div>
    <div
      v-if="acknowledgementsOption"
      style="display: block"
      class="acknowledgementsDialog dark:bg-purple-600"
    >
      <div style="display: block; margin-bottom: 15px">
        <button
          style="
            float: right;
            position: relative;
            padding-left: 0;
            z-index: 100;
          "
          v-on:click="acknowledgementsClosed"
        >
          <svg
            width="36px"
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="22.5" cy="22.5" r="22.5" fill="#E8E6FF" />
            <path
              d="M20.0778 27.6407C20.2388 27.811 20.4625 27.9097 20.7131 27.9097C21.2052 27.9097 21.6078 27.5062 21.6078 27.013C21.6078 26.7619 21.5094 26.5378 21.3483 26.3764L18.4046 23.4263H26.9763C27.4685 23.4263 27.8711 23.0228 27.8711 22.5297C27.8711 22.0365 27.4685 21.633 26.9763 21.633H18.3957L21.3394 18.683C21.5005 18.5216 21.5989 18.2974 21.5989 18.0463C21.5989 17.5532 21.1962 17.1497 20.7041 17.1497C20.4536 17.1497 20.2299 17.2483 20.0688 17.4097L15.5951 21.893C15.434 22.0544 15.3356 22.2786 15.3356 22.5297C15.3356 22.7807 15.443 22.9959 15.604 23.1573L20.0778 27.6407Z"
              fill="#8380A8"
            />
          </svg>
        </button>
        <div v-if="$store.state.darkMode">
          <div class="newlogoDark"></div>
        </div>
        <div v-else>
          <div class="newlogo"></div>
        </div>
      </div>
      <br />
      <!-- info help part 1 -->
      <div class="fade">
        <div class="infoPic infoPic1" />
        <div class="alginCenterDiv">
          <div role="dialog">
            <h1 class="InfoDialogTitle dark:text-white">About</h1>
            <p class="infoParagraphs dark:text-white">
              The Wellness Services Navigator has been built with the
              collaborative efforts of the Office of Student Affairs, Health and
              Counselling Services, undergraduate students Neha Khanna
              (Neuroscience and Mental Health) and Mohammad Al-Hemed (Computer
              Science) who participated in the Students as Partners program, Drs
              Zachary Patterson and Kim Hellemans (Department of Neuroscience)
              and co-op student Brady Hoard (Information Technology). We
              gratefully accept any feedback or comments; please contact
              <a
                class="
                  text-link-blue
                  font-bold
                  pb-0
                  border-b
                  dark:text-link-light-blue
                "
                href="mailto:wellness@carleton.ca"
                >wellness@carleton.ca</a
              >.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  data: function () {
    return {
      acknowledgementsOption: false,
    };
  },
  methods: {
    acknowledgementsClicked() {
      this.acknowledgementsOption = true;
    },

    acknowledgementsClosed() {
      this.acknowledgementsOption = false;
    },
  },
};
</script>
